import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { GroupDescriptor, State, CompositeFilterDescriptor, FilterDescriptor, process } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent, FilterService } from '@progress/kendo-angular-grid';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
// import { ApiService, flatten, distinct } from '../api.service';
// import { Flow } from '../flows/flow';
// import { PowerApp } from './powerapp';
import { PowerBaseComponent } from './powerbase.component';
import { PowerApp } from '../obj/PowerApp';
import { FlowManagementService, distinct, flatten } from '../services/flow-management.service';

@Component({
    selector: 'app-powerapps',
    templateUrl: './powerapps.component.html',
    styleUrls: ['./powerapps.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class PowerAppsComponent extends PowerBaseComponent implements OnInit {

  public apiRoot = 'https://make.powerapps.com';
  public ready = true;
  public selection: string[] = [];
  //public apps: PowerApp[] = [];
  flowEnvironments: string[] = [];
  creators: string[] = [];

  // @ViewChild('grid') grid;

  constructor(
    public apiService: FlowManagementService,
    public sanitizer: DomSanitizer
  ) {
    super(apiService, sanitizer);
  }

  ngOnInit() {
    this.reload();
  }

  async reload() {
    try {
      this.ready = false;
      const apps = await this.apiService.getApps(this.apiService.currentEnvironment, false)

      this.items = apps;
      // this.flowTriggers = this.flows.map( flow => flow.trigger ).filter(distinct).sort();
      // this.flowTriggerKinds = this.flows.map( flow => flow.triggerKind ).filter(distinct).sort();
      // this.flowStates = this.flows.map( flow => flow.flowState ).filter(distinct).sort();
      // this.flowEnvironments = this.apps.map( item => item.environment).filter(distinct).sort();
      this.creators = this.items.map( item => item.ownerName).filter(distinct).sort();

      // this.view = process(this.items, this.state);
      this.updateView();
    }
    finally {
      this.ready = true;
    };
  }

  public bgColor(flow: any) {
      var tags = flow.tags || [];

      for (var i = 0; i < tags.length; i++) {
          var tag = tags[i].replace('#', '').toLowerCase();

          // if (typeof colours[tag] != 'undefined') {
          //     //return tag;
          //     return this.sanitizer.bypassSecurityTrustStyle(tag);
          // }
      }
      return null;
  }

  // get ready(): boolean {
  //   return true;
  //     // var env = this.flowManagementService.currentEnvironment;
  //     // return this.loaded && !!env;
  // }
//   filterByTrigger(trigger: string) {
//     var state: any = this.state;
//     if (trigger) {
//         if (state.filter.filters && state.filter.filters.length && state.filter.filters[0].value == trigger) {
//             state.filter.filters = [];
//         }
//         else {
//             state.filter.filters = [{
//                 "field": "trigger",
//                 "operator": "contains",
//                 "value": trigger
//             }];
//             state.skip = 0;
//         }
//     }
//     else {
//         state.filter.filters = [];
//     }
//     this.dataStateChange(state);
// }

  filterBy(field: string, value: string, toggle: boolean = true) {
    var state: any = this.state;
    if (value) {
        if (state.filter.filters && state.filter.filters.length && state.filter.filters[0].value == value && toggle) {
            state.filter.filters = [];
        }
        else {
            state.filter.filters = [{
                "field": field,
                "operator": "contains",
                "value": value
            }];
            state.skip = 0;
        }
    }
    else {
        state.filter.filters = [];
    }
    this.dataStateChange(state);
  }

  filterByTrigger(trigger: string) {
    this.filterBy("trigger", trigger);
  }

  filterByTriggerKind(triggerKind: string) {
      this.filterBy("triggerKind", triggerKind);
  }

  filterByFlowState(flowState: string) {
      this.filterBy("flowState", flowState);
  }

  clearFilter() {
    var state: any = this.state;
    state.filter.filters = [];
    this.dataStateChange(state);
  }

  get hasFilter() {
    var hasFilter = false;

    try {
      hasFilter = this.state.filter.filters.length > 0;
    }
    catch (e) {
      // nothing.
    }

    return hasFilter;
  }

}
